import { render, staticRenderFns } from "./SnapDelete.vue?vue&type=template&id=720ccbef&"
import script from "./SnapDelete.vue?vue&type=script&lang=js&"
export * from "./SnapDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports